import {
  ApiRemoveDiscountCodeRequestedAction,
  apiRemoveDiscountCodeFailed,
  apiRemoveDiscountCodeSucceeded
} from '@spa/lib/store/api/cart/removeDiscountCodeApi';
import { call, put } from 'typed-redux-saga';
import removeDiscountCodeAction, {
  RemoveDiscountCodeActionInput,
  RemoveDiscountCodeActionResult
} from '@spa/lib/actions/cart/removeDiscountCodeAction';

function* removeDiscountCodeSaga({
  payload: { codeId, customOrderType, parentActionId, actionId: requestedActionId }
}: ApiRemoveDiscountCodeRequestedAction): Generator {
  try {
    const input: RemoveDiscountCodeActionInput = { customOrderType, codeId };
    const { cartId, result }: RemoveDiscountCodeActionResult = yield* call(
      removeDiscountCodeAction,
      'removeDiscountCodeAction',
      input
    );

    yield* put(
      apiRemoveDiscountCodeSucceeded({
        requestedActionId,
        parentActionId,
        result,
        cartId
      })
    );
  } catch {
    yield* put(apiRemoveDiscountCodeFailed({ requestedActionId, parentActionId }));
  }
}

export default removeDiscountCodeSaga;
